import React from 'react';
import { Dropdown, Icon } from "semantic-ui-react";

/**
 * Reusable dropdown component with reset button
 * Combines Semantic UI Dropdown with a reset icon for clearing selections
 * 
 * @param {string} name - Name of the filter field
 * @param {string} placeholder - Placeholder text for dropdown
 * @param {Array} options - Dropdown options array
 * @param {*} value - Current selected value
 * @param {Function} onChange - Change handler
 * @param {Object} style - Additional inline styles
 * @param {string} className - Additional CSS classes
 * @param {boolean} multiple - Whether multiple selections are allowed
 * @param {boolean} search - Whether dropdown is searchable
 * @param {boolean} selection - Whether to show as selection dropdown
 */
const DropdownWithReset = ({
    name,
    placeholder,
    options,
    value,
    onChange,
    style = { minWidth: '200px' },
    className = 'float-right',
    multiple = false,
    search = true,
    selection = true
}) => {
    return (
        <div className="dropdown-wrapper">
            <Icon 
                name="close" 
                link 
                color="grey" 
                className="reset-icon" 
                title="Reset"
                onClick={(e) => onChange(e, { name, value: 'reset' })} 
            />
            <Dropdown 
                style={style} 
                className={className} 
                placeholder={placeholder}
                selection={selection}
                search={search}
                multiple={multiple}
                name={name} 
                value={value}
                options={options} 
                onChange={onChange} 
            />
        </div>
    );
};

export default DropdownWithReset;
